angular.module('zc.core')
  .controller('TosController', TosController);

TosController.$inject = ['$rootScope'];
function TosController($rootScope) {
  const vm = this;

  vm.$onInit = () => {
    vm.selectedLanguage = null;

    // Select TOS based on the language selected in TosHeaderController
    const deregistrationCallback = $rootScope.$on('languageSelected', (_, selectedLanguage) => {
      vm.selectedLanguage = selectedLanguage;
    });

    $rootScope.$on('$destroy', deregistrationCallback);

    $rootScope.$emit('selectDefaultLanguage');
  };
}



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/views/tos.js